import styled from 'styled-components';

export const Botao = styled.button.attrs((props) => ({
  type: props.tipo,
  id: props.id,
}))`
  font-size: 15px;
  margin: 10px 0px;
  color: #ffffff;
  font-family: 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', sans-serif;
  border: 2px solid ${(props) => (props.bg != undefined ? props.bg : '#1D3054')};
  background-color: ${(props) =>
    props.bg != undefined ? props.bg : '#1D3054'};
  font-weight: 900;
  height: 40px;
  width: 264px;
  cursor: pointer;
  border-radius: 4px;
  transition: 0.3s;
  padding: 0px;
  a {
    text-decoration: none;
    color: #ffffff;
  }
  &:disabled {
    cursor: not-allowed;
    border: none;
    background-color: #d1d1d1;
    color: #ffffff;
    &:hover {
      box-shadow: none;
    }
  }
  // @media (max-width: 768px) {
  //   width: 265px;
  // }
  &:hover {
    box-shadow: 0px 0px 8px
      ${(props) => (props.bg != undefined ? props.bg : '#1D3054')};
  }
`;

export const BotaoMenor = styled(Botao)`
  width: ${(props) => (props.width != undefined ? props.width : '264px')};
  &:disabled {
    cursor: not-allowed;
    border: none;
    background-color: #d1d1d1;
    color: #ffffff;
    &:hover {
      box-shadow: none;
    }
  }
`;

export const BotaoComClose = styled(BotaoMenor)`
  width: 230px;
`;

export const BotaoAlterarDados = styled(BotaoMenor)`
  width: 264px;
`;

export const BotaoError = styled(Botao)`
  background-color: #ffffff;
  color: #b61817;
  border: 2px solid #b61817;
  width: 265px;
  &:hover {
    box-shadow: 0px 0px 8px #b61817 !important;
  }
`;

export const Spinner = styled.div`
  width: ${({ size }) => size || '16'}px;
  aspect-ratio: 1;
  border-radius: 50%;
  border: 3px solid #1d3054;
  animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;

  @keyframes l20-1 {
    0% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
    }
    12.5% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 0%,
        100% 0%,
        100% 0%
      );
    }
    25% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        100% 100%,
        100% 100%
      );
    }
    50% {
      clip-path: polygon(
        50% 50%,
        0 0,
        50% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    62.5% {
      clip-path: polygon(
        50% 50%,
        100% 0,
        100% 0%,
        100% 0%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    75% {
      clip-path: polygon(
        50% 50%,
        100% 100%,
        100% 100%,
        100% 100%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    100% {
      clip-path: polygon(
        50% 50%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        0% 100%
      );
    }
  }
  @keyframes l20-2 {
    0% {
      transform: scaleY(1) rotate(0deg);
    }
    49.99% {
      transform: scaleY(1) rotate(135deg);
    }
    50% {
      transform: scaleY(-1) rotate(0deg);
    }
    100% {
      transform: scaleY(-1) rotate(-135deg);
    }
  }
`;
/* HTML: <div class="loader"></div> */

const Button = styled.button`
  margin: 0px 25px;
  height: 45px;
  width: 154px;
  transition: 0.3s;
  border: none;
  border-radius: 10px;
  cursor: pointer;
`;

export const Cancel = styled(Button)`
  background-color: transparent;
  border: 2px solid #b1b3b3 !important;
  &:hover {
    background-color: #b61817;
    box-shadow: 0px 0px 8px #b61817;
  }
`;

export const Save = styled(Button)`
  background-color: #1d3054;
  &:hover {
    box-shadow: 0px 0px 15px #1d3054;
  }
`;

export const ButtonPrimary = styled.button`
  width: ${(props) => (props?.width ? props.width + 'px' : 'auto')};
  width: ${(props) => (props?.fullWidth ? '100%' : '')};
  height: 46px;

  color: ${(props) => (props?.light ? props?.tema?.primaryColor : '#fff')};
  color: ${(props) => (props?.ghost ? '#fff' : '')};
  color: ${(props) => (props?.white ? props?.tema?.primaryColor : '')};

  background-color: ${(props) =>
    props?.light ? 'transparent' : props?.tema?.primaryColor};
  background-color: ${(props) => (props?.ghost ? 'transparent' : '')};
  background-color: ${(props) => (props?.white ? '#fff' : '')};

  text-transform: uppercase;
  font-family: 24px;
  font-weight: bolder;

  border: 2px solid
    ${(props) => (props?.light ? props?.tema?.primaryColor : 'transparent')};
  border-color: ${(props) => (props?.ghost ? '#fff' : '')};

  border-radius: 5px;
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 16px;
  transition: 0.3s;
  &:hover {
    box-shadow: 0px 0px 8px
      ${({ white, ghost, tema }) =>
        white || ghost ? '#fff' : tema?.primaryColor};
  }

  &:disabled {
    cursor: not-allowed;
    border: none;
    background-color: #d1d1d1;
    color: #ffffff;
    &:hover {
      box-shadow: none;
    }
  }

  a {
    width: 100%;
    text-decoration: none;
    color: ${(props) => (props?.light ? props?.tema?.primaryColor : '#fff')};
  }
`;

export const ButtonDanger = styled.button`
  width: ${(props) => (props?.fullWidth ? '100%' : 'auto')};
  height: 46px;
  color: ${(props) => (props?.light ? '#ba122b' : '#fff')};
  background-color: ${(props) => (props?.light ? '#fff' : '#ba122b')};
  text-transform: uppercase;
  font-family: 24px;
  font-weight: bolder;
  border: 2px solid ${(props) => (props?.light ? '#ba122b' : 'transparent')};
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  &:hover {
    box-shadow: 0px 0px 8px #ba122b;
  }

  &:disabled {
    cursor: not-allowed;
    border: none;
    background-color: #d1d1d1;
    color: #ffffff;
    &:hover {
      box-shadow: none;
    }
  }
`;
